import React from "react";
import { FormattedHTMLMessage } from "react-intl";

import { VerificationService, ThirdPartyLoopResponse } from "../../lib/types/types";
import { ThirdPartyLoopProvider, VerificationStepsEnum } from "../../lib/types/runtimeTypes";
import { ButtonType, SingleSignOnComponent, SingleSignOnMessages } from "../SingleSignOnComponent";
import { LogoComponent } from "../LogoComponent/LogoComponent";
import { AnnouncingHeader } from "../AnnouncingHeader/AnnouncingHeader";

interface StepThirdPartyLoopProps {
  verificationService: VerificationService;
}

export const thirdPartyLoopMessageMap: {
  [key in ThirdPartyLoopProvider]: SingleSignOnMessages;
} = {
  [ThirdPartyLoopProvider.SIGNZY]: {
    title: (
      <FormattedHTMLMessage
        id="step.thirdPartyLoop.signzy.title"
        tagName="h1"
        defaultMessage="Verify using DigiLocker"
      />
    ),
    subtitle: (
      <FormattedHTMLMessage
        id="step.thirdPartyLoop.signzy.subtitle"
        defaultMessage="Verify using your DigiLocker login information"
      />
    ),
    login: (
      <FormattedHTMLMessage
        id="step.thirdPartyLoop.signzy.login"
        defaultMessage="Sign in to DigiLocker"
      />
    ),
    cancel: (
      <FormattedHTMLMessage
        id="step.thirdPartyLoop.signzy.cancel"
        defaultMessage="Upload Proof of Identity"
      />
    ),
  },
};

export const ThirdPartyLoopError = ({ logo }: { logo: React.ReactNode }) => (
  <div
    id="sid-step-third-party-loop"
    className="sid-step-third-party-loop-container sid-l-container"
    data-testid="sid-step-third-party-loop-error"
  >
    <div className="sid-header sid-l-horz-center">
      <div className="sid-error-logo-container sid-l-horz-center">{logo}</div>
      <AnnouncingHeader align="center">
        <FormattedHTMLMessage id="error" tagName="h1" />
      </AnnouncingHeader>
      <div className="sid-header__subtitle sid-l-horz-center sid-l-space-top-md">
        <div className="sid-error-msg sid-l-horz-center">
          <FormattedHTMLMessage
            id="step.thirdPartyLoop.error"
            defaultMessage="Provider not supported"
          />
        </div>
      </div>
    </div>
  </div>
);

const StepThirdPartyLoopComponent = ({ verificationService }: StepThirdPartyLoopProps) => {
  const verificationResponse = verificationService.verificationResponse as ThirdPartyLoopResponse;
  const messages =
    thirdPartyLoopMessageMap[verificationResponse.thirdPartyLoopProvider] || undefined;

  if (!messages) {
    return (
      <ThirdPartyLoopError
        logo={
          <LogoComponent
            verificationService={verificationService}
            fallbackLogo={
              <img
                className="sid-error-logo sid-l-lead-image"
                alt=""
                src="https://assets-resources.sheerid.com/common/images/2018/icons/circle-exclamation.svg"
              />
            }
          />
        }
      />
    );
  }

  return (
    <SingleSignOnComponent
      verificationService={verificationService}
      stepName={VerificationStepsEnum.thirdPartyLoop}
      messages={messages}
      cancelButtonType={ButtonType.SECONDARY}
    />
  );
};

export { StepThirdPartyLoopComponent };
